import { Routes } from '@/router/routes'

import { AppPermissions } from '@/types/enums/permissions/permissions'
import { Middleware } from '@/types/enums/middleware/middleware'

import type { RouteLocation } from 'vue-router'

export const experiencesRoutes = [
  {
    path: '/experiences',
    name: Routes.Experiences,
    component: () => import('@/pages/contexts/portal/experiences/Index.vue'),
    meta: {
      pageTitle: 'Manage Experiences',
      middleware: [
        Middleware.REQUIRES_AUTH,
        Middleware.TOGGLES_NAV_DRAWER,
      ],
      permission: AppPermissions.VIEW_EXPERIENCES,
    },
    children: [
      {
        path: 'create',
        name: Routes.ExperienceCreate,
        component: () => import('@/pages/contexts/portal/experiences/Create.vue'),
        meta: {
          middleware: [
            Middleware.REQUIRES_AUTH,
            Middleware.TOGGLES_NAV_DRAWER,
          ],
          permission: AppPermissions.MANAGE_EXPERIENCES,
        },
      },
    ],
  },
  {
    path: '/experiences/edit/:experienceId',
    name: Routes.ExperienceEdit,
    component: () => import('@/pages/contexts/portal/experiences/_experienceId/Index.vue'),
    meta: {
      pageTitle: 'Manage Experience',
      middleware: [
        Middleware.REQUIRES_AUTH,
        Middleware.TOGGLES_NAV_DRAWER,
      ],
      permission: AppPermissions.VIEW_EXPERIENCES,
    },
    redirect: (to: RouteLocation) => ({
      name: Routes.ExperienceEditOverview,
      params: {
        experienceId: to.params.experienceId,
      },
    }),
    children: [
      {
        path: 'overview',
        name: Routes.ExperienceEditOverview,
        component: () => import('@/pages/contexts/portal/experiences/_experienceId/overview/Index.vue'),
        meta: {
          pageTitle: 'Experience Overview',
          middleware: [
            Middleware.REQUIRES_AUTH,
            Middleware.TOGGLES_NAV_DRAWER,
          ],
          permission: AppPermissions.MANAGE_EXPERIENCES,
        },
      },
      {
        path: 'location',
        name: Routes.ExperienceEditLocation,
        component: () => import('@/pages/contexts/portal/experiences/_experienceId/location/Index.vue'),
        meta: {
          pageTitle: 'Experience Location',
          middleware: [
            Middleware.REQUIRES_AUTH,
            Middleware.TOGGLES_NAV_DRAWER,
          ],
          permission: AppPermissions.MANAGE_EXPERIENCES,
        },
      },
      {
        path: 'schedule',
        name: Routes.ExperienceEditSchedule,
        component: () => import('@/pages/contexts/portal/experiences/_experienceId/schedule/Index.vue'),
        meta: {
          pageTitle: 'Experience Schedule',
          middleware: [
            Middleware.REQUIRES_AUTH,
            Middleware.TOGGLES_NAV_DRAWER,
          ],
          permission: AppPermissions.MANAGE_EXPERIENCES,
        },
      },
      {
        path: 'requirements',
        name: Routes.ExperienceEditRequirements,
        component: () => import('@/pages/contexts/portal/experiences/_experienceId/requirements/Index.vue'),
        meta: {
          pageTitle: 'Experience Requirements',
          middleware: [
            Middleware.REQUIRES_AUTH,
            Middleware.TOGGLES_NAV_DRAWER,
          ],
          permission: AppPermissions.MANAGE_EXPERIENCES,
        },
      },
      {
        path: 'transport',
        name: Routes.ExperienceEditTransport,
        component: () => import('@/pages/contexts/portal/experiences/_experienceId/transport/Index.vue'),
        meta: {
          pageTitle: 'Experience Transport',
          middleware: [
            Middleware.REQUIRES_AUTH,
            Middleware.TOGGLES_NAV_DRAWER,
          ],
          permission: AppPermissions.MANAGE_EXPERIENCES,
        },
      },
      {
        path: 'visibility',
        name: Routes.ExperienceEditVisibility,
        component: () => import('@/pages/contexts/portal/experiences/_experienceId/visibility/Index.vue'),
        meta: {
          pageTitle: 'Experience Visibility',
          middleware: [
            Middleware.REQUIRES_AUTH,
            Middleware.TOGGLES_NAV_DRAWER,
          ],
          permission: AppPermissions.MANAGE_EXPERIENCES,
        },
      },
      {
        path: 'trip-scripts',
        name: Routes.ExperienceEditTripScripts,
        component: () => import('@/pages/contexts/portal/experiences/_experienceId/trip-scripts/Index.vue'),
        meta: {
          pageTitle: 'Experience Trip Scripts',
          middleware: [
            Middleware.REQUIRES_AUTH,
            Middleware.TOGGLES_NAV_DRAWER,
          ],
          permission: AppPermissions.MANAGE_EXPERIENCES,
        },
      },
    ],
  },
]
